import HomeServicesAlert from "components/home-services/home-services-alert";
import CancellationPaymentNotice from "components/shared/cancellation-payment-notice";
import {
  useShowCancellationPaymentNotice,
  useShowCoverageNotification,
  useShowHomeServicesAlert,
  useShowLeakBotBanner,
} from "components/shared/notifications/hooks";
import CoverageNotification from "pages/overview/extended-coverages/coverage-notification";

import { LeakBotBanner } from "../leakbot-banner";
import { ScheduledPaymentNotification } from "../scheduled-payment-notification";

export type NotificationName =
  | "CancellationPayment"
  | "Coverage"
  | "HomeServices"
  | "Leakbot"
  | "ScheduledPayment";

type Props = {
  availableNotifications: NotificationName[];
};

export const Notifications = ({ availableNotifications }: Props) => {
  const showScheduledPaymentNotifications =
    availableNotifications.includes("ScheduledPayment");

  const showLeakbotBanner = useShowLeakBotBanner(availableNotifications);

  const showHomeServiceAlert = useShowHomeServicesAlert(availableNotifications);
  const showCancellationPaymentNotice = useShowCancellationPaymentNotice(
    availableNotifications
  );
  const showCoverageNotification = useShowCoverageNotification(
    availableNotifications
  );

  return (
    <>
      {showHomeServiceAlert && <HomeServicesAlert />}
      {showCancellationPaymentNotice && <CancellationPaymentNotice />}
      {showScheduledPaymentNotifications && <ScheduledPaymentNotification />}
      {showLeakbotBanner && <LeakBotBanner />}
      {showCoverageNotification && <CoverageNotification />}
    </>
  );
};
